

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';

export class TransDocumentListParams extends BaseEntity
{   
    public RefDateFrom: Date; 
    public RefDateUntil: Date; 
    public IsOpen: boolean; 
    public CompanyID: number; 
    public HasComplexFilter: boolean; 
	
}



